import React from 'react';
import Link from 'gatsby-link';

import styles from './logo.module.scss';

const Logo = (props) => {
  return <Link to='/' styleName='logo' {...props}></Link>;
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/index.js